(function () {
  var megaCloseTimer = null;
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function findShopTrigger() {
    var links = Array.prototype.slice.call(document.querySelectorAll('.codex-yn-header__nav a'));
    return links.find(function (link) {
      return link.textContent.trim().toLowerCase() === 'shop';
    }) || links[0] || null;
  }

  function positionMega(mega) {
    var header = document.getElementById('page-header');
    var top = header ? header.getBoundingClientRect().bottom : 0;
    mega.style.setProperty('--codex-mega-top', Math.max(0, Math.round(top)) + 'px');
  }

  function openMega() {
    var mega = document.querySelector('[data-codex-shop-mega]');
    if (!mega || mobileQuery.matches) return;
    window.clearTimeout(megaCloseTimer);
    positionMega(mega);
    mega.classList.add('is-open');
    mega.setAttribute('aria-hidden', 'false');
  }

  function closeMega() {
    var mega = document.querySelector('[data-codex-shop-mega]');
    if (!mega) return;
    mega.classList.remove('is-open');
    mega.setAttribute('aria-hidden', 'true');
  }

  function scheduleMegaClose() {
    window.clearTimeout(megaCloseTimer);
    megaCloseTimer = window.setTimeout(closeMega, 140);
  }

  function setupMegaMenu() {
    var mega = document.querySelector('[data-codex-shop-mega]');
    var trigger = findShopTrigger();
    if (!mega || !trigger || trigger.dataset.codexMegaBound === 'true') return;
    trigger.dataset.codexMegaBound = 'true';
    trigger.classList.add('codex-shop-mega-trigger');
    trigger.setAttribute('aria-haspopup', 'true');

    trigger.addEventListener('click', function (event) {
      if (mobileQuery.matches) return;
      event.preventDefault();
      if (mega.classList.contains('is-open')) {
        closeMega();
      } else {
        openMega();
      }
    });
    trigger.addEventListener('mouseenter', openMega);
    trigger.addEventListener('focus', openMega);
    trigger.addEventListener('mouseleave', scheduleMegaClose);
    mega.addEventListener('mouseenter', function () { window.clearTimeout(megaCloseTimer); });
    mega.addEventListener('mouseleave', scheduleMegaClose);

    document.addEventListener('click', function (event) {
      if (!mega.classList.contains('is-open')) return;
      if (mega.contains(event.target) || trigger.contains(event.target)) return;
      closeMega();
    });
    window.addEventListener('resize', function () {
      if (mobileQuery.matches) closeMega();
      if (mega.classList.contains('is-open')) positionMega(mega);
    });
    window.addEventListener('scroll', function () {
      if (mega.classList.contains('is-open')) positionMega(mega);
    }, { passive: true });
  }

  function setupMobileMenuButton() {
    var bar = document.querySelector('.codex-yn-header__bar');
    if (!bar || bar.querySelector('[data-codex-mobile-trigger]')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'codex-yn-header__menu';
    button.setAttribute('aria-label', 'Open menu');
    button.setAttribute('aria-controls', 'codex-mobile-main-menu');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('data-codex-mobile-trigger', 'true');
    button.innerHTML = '<span aria-hidden="true"></span>';
    bar.insertBefore(button, bar.firstChild);
  }

  function setupMobileMenu() {
    var menu = document.getElementById('codex-mobile-main-menu');
    var trigger = document.querySelector('[data-codex-mobile-trigger]');
    if (!menu || !trigger || trigger.dataset.codexMobileBound === 'true') return;
    trigger.dataset.codexMobileBound = 'true';
    var closeControls = menu.querySelectorAll('[data-codex-mobile-close]');

    function openMenu() {
      closeMega();
      menu.hidden = false;
      window.requestAnimationFrame(function () {
        menu.classList.add('is-open');
        document.body.classList.add('codex-mobile-menu-open');
        trigger.setAttribute('aria-expanded', 'true');
      });
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      document.body.classList.remove('codex-mobile-menu-open');
      trigger.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () {
        if (!menu.classList.contains('is-open')) menu.hidden = true;
      }, 220);
    }

    trigger.addEventListener('click', openMenu);
    Array.prototype.forEach.call(closeControls, function (control) {
      control.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });
  }

  function setFooterPolicyLinks() {
    var list = document.querySelector('.codex-footer-polish__links');
    if (!list || list.dataset.codexPolicyReady === 'true') return;
    var links = [
      ['About Us', '/pages/about-us-1'],
      ['Account', 'https://account.youngnoise.com'],
      ['Returns & Exchanges', 'https://www.youngnoise.com/pages/return-policy'],
      ['Contact us', '/pages/contact'],
      ['Shipping Policy', '/policies/shipping-policy'],
      ['Return Policy', '/pages/return-policy'],
      ['Privacy Policy', '/pages/privacy-policy']
    ];
    list.innerHTML = '';
    links.forEach(function (item) {
      var li = document.createElement('li');
      var link = document.createElement('a');
      link.href = item[1];
      link.textContent = item[0];
      li.appendChild(link);
      list.appendChild(li);
    });
    list.dataset.codexPolicyReady = 'true';
  }

  function moveFooter() {
    var template = document.getElementById('codex-footer-template');
    if (!template || document.querySelector('.codex-footer-polish')) {
      setFooterPolicyLinks();
      return;
    }
    var clone = template.content ? template.content.cloneNode(true) : null;
    if (!clone) return;
    var footer = document.querySelector('footer.footer');
    if (footer && footer.parentNode) {
      footer.parentNode.insertBefore(clone, footer.nextSibling);
    } else {
      document.body.appendChild(clone);
    }
    document.body.classList.add('codex-footer-ready');
    setFooterPolicyLinks();
  }

  function fixDeliveryText(root) {
    var start = root && root.nodeType === 1 ? root : document.body;
    if (!start) return;
    var pattern = /(Delivery\s*)?2\s*[\u2013\u2014-]\s*4(\s*days?)/i;
    var walker = document.createTreeWalker(start, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return pattern.test(node.nodeValue) || /2\s+to\s+4/i.test(node.nodeValue)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(function (textNode) {
      textNode.nodeValue = textNode.nodeValue
        .replace(/Delivery\s*2\s*[\u2013\u2014-]\s*4\s*days?/gi, 'Delivery 2-5 days')
        .replace(/2\s*[\u2013\u2014-]\s*4\s*days?/gi, '2-5 days')
        .replace(/2\s+to\s+4/gi, '2 to 5');
    });
  }

  function observeDeliveryText() {
    fixDeliveryText(document.body);
    if (!window.MutationObserver) return;
    var pending = false;
    var observer = new MutationObserver(function (mutations) {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node.nodeType === 1) fixDeliveryText(node);
            if (node.nodeType === 3) fixDeliveryText(node.parentNode || document.body);
          });
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { fixDeliveryText(document.body); }, 1200);
    window.setTimeout(function () { fixDeliveryText(document.body); }, 3000);
  }

  ready(function () {
    setupMobileMenuButton();
    setupMegaMenu();
    setupMobileMenu();
    moveFooter();
    observeDeliveryText();
  });
})();
